(function () {
  'use strict';

  /* @ngdoc object
   * @name flyingHourSummaryReport
   * @description
   *
   */
  angular
    .module('flyingHourSummaryReport', [
      'ui.router'
    ]);
}());
